import AICampusFooter from "@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue";
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";
import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';
import {
  PUBLIC_JOB_CATALOG_URL,
  GET_JOB_PROFILE_DETAILS_URL,
  PUBLIC_JOB_ADVERT_URL,
  APPLY_FOR_ENTITY_TYPE,
  CHECK_APPLIED_STATUS_URL,
  GET_USER_APPLIED_ENTITY_TYPE_IDS_URL,
  GET_ALL_USER_APPLICATIONS,
  get_headers,
  get_token,
} from "@/utils/constants/constants";
import axios from "axios";
import alert_mixin from "@/utils/mixins/alert_mixin";


export default {
  name: "ApplyForJobs",
  mixins: [alert_mixin],
  components: {
    AICampusFooter,
    NavigationBackButton,
    navbar
  },
  data: () => ({
    currently_logged_in: sessionStorage.getItem('lead_name'),
    showFilters: false,
    hostname: window.location.hostname,
    headers: get_headers(),
    projects: [],
    sub_programs: [],
    jobs: [],
    loading_jobs: false,
    has_loaded_jobs_once: false,
    current_page: 1,
    items_per_page: 10,
    filters: {
      programmeId: '',
      status: '',
      search: '',
      sortBy: 'recent',
    },
    status_options: [
      { value: '', label: 'All Statuses' },
      { value: 'Open', label: 'Open' },
      { value: 'Closing Soon', label: 'Closing Soon' },
      { value: 'Closed', label: 'Closed' },
    ],
    loading_profile: false,
    job_profile: {
      title: '',
      description: '',
      sections: [],
      advert_details: '',
      advert_sections: [],
      advert_order: [],
      display_blocks: [],
    },
    job: {
        id: null,
      advertId: null,
      alreadyApplied: false,
      applicationState: null,
        projectId: null,
        departmentId: null,
        title: '',
        jobTitle: '',
        departmentName: '',
        status: '',
        recruitingPeriod: '',
      informationSummary: [],
      formSections: [],
      jobSpecSections: [],
      jobPurpose: '',
      rawSpecText: '',
        details: '',
        shareLink: '',
        referenceNumber: '',
        competencies: [],
    },
  }),

  computed: {
    visible_profile_sections() {
      if (!this.job_profile.sections || !this.job_profile.sections.length) return [];
      return this.job_profile.sections.filter(s => s.show_on_advert !== false);
    },

    programme_options() {
      return (this.sub_programs || []).map((sp) => ({
        label: sp.name,
        value: String(sp.id),
      }));
    },

    filtered_jobs() {
      const search_text = (this.filters.search || '').trim().toLowerCase();

      let filtered = (this.jobs || []).filter((job) => {
        const matches_programme = !this.filters.programmeId || String(job.subProgramId) === String(this.filters.programmeId);
        const matches_status = !this.filters.status || job.status === this.filters.status;
        const matches_search = !search_text
          || (job.jobTitle || '').toLowerCase().includes(search_text)
          || (job.referenceNumber || '').toLowerCase().includes(search_text);

        return matches_programme && matches_status && matches_search;
      });

      if (this.filters.sortBy === 'title') {
        filtered = filtered.sort((left, right) => (left.jobTitle || '').localeCompare(right.jobTitle || ''));
      } else if (this.filters.sortBy === 'closing') {
        filtered = filtered.sort((left, right) => {
          const left_date = left.closingDate ? new Date(left.closingDate).getTime() : Number.MAX_SAFE_INTEGER;
          const right_date = right.closingDate ? new Date(right.closingDate).getTime() : Number.MAX_SAFE_INTEGER;
          return left_date - right_date;
        });
      } else {
        filtered = filtered.sort((left, right) => {
          const left_date = left.publishedDate ? new Date(left.publishedDate).getTime() : 0;
          const right_date = right.publishedDate ? new Date(right.publishedDate).getTime() : 0;
          return right_date - left_date;
        });
      }

      return filtered;
    },

    paginated_jobs() {
      const start = (this.current_page - 1) * this.items_per_page;
      const end = start + this.items_per_page;
      return this.filtered_jobs.slice(start, end);
    },

    total_pages() {
      return Math.ceil(this.filtered_jobs.length / this.items_per_page);
    },
  },

  async created() {
    await this.ensure_jobs_loaded();
  },

  activated() {
    this.ensure_jobs_loaded();
  },

  methods: {
    read_prop(target, key, fallback = null) {
      if (!target || !Reflect.has(target, key)) {
        return fallback;
      }
      const value = Reflect.get(target, key);
      return value ?? fallback;
    },

    async ensure_jobs_loaded() {
      if (this.loading_jobs) {
        return;
      }

      if (this.has_loaded_jobs_once && this.jobs.length) {
        return;
      }

      await this.fetch_jobs_for_all_projects();
    },

    normalize_api_payload(raw_payload) {
      if (!raw_payload) {
        const empty_payload = {};
        return empty_payload;
      }

      if (typeof raw_payload === 'string') {
        try {
          return JSON.parse(raw_payload);
        } catch (error) {
          const invalid_payload = {};
          return invalid_payload;
        }
      }

      return raw_payload;
    },

    infer_job_status(closing_date) {
      if (!closing_date) {
        return 'Open';
      }

      const now = new Date();
      const closing = new Date(closing_date);
      const ms_remaining = closing.getTime() - now.getTime();
      const days_remaining = ms_remaining / (1000 * 60 * 60 * 24);

      if (days_remaining < 0) {
        return 'Closed';
      }

      if (days_remaining <= 7) {
        return 'Closing Soon';
      }

      return 'Open';
    },

    get_status_badge_class(status) {
      if (status === 'Closed') {
        return 'text-bg-secondary';
      }

      if (status === 'Closing Soon') {
        return 'text-bg-warning';
      }

      return 'text-bg-success';
    },

    normalize_application_state(state) {
      return ['applied', 'archived'].includes(state) ? state : null;
    },

    get_job_action_label(job = this.job) {
      if (job?.alreadyApplied) return 'Applied';
      if (job?.applicationState === 'archived') return 'Continue';
      return job?.status === 'Closed' ? 'Closed' : 'Apply';
    },

    clear_filters() {
      this.filters = {
        programmeId: '',
        status: '',
        search: '',
        sortBy: 'recent',
      };
      this.current_page = 1;
    },
    on_filter_change() {
      this.current_page = 1;
    },


    get_spec_lines(spec_text) {
      if (!spec_text) {
        return [];
      }

      // If it's already an object/array, stringify it safely
      let text = '';

      if (typeof spec_text === 'string') {
        text = spec_text;
      } else if (typeof spec_text === 'object') {
        try {
          text = JSON.stringify(spec_text, null, 2);
        } catch (e) {
          text = '';
        }
      } else {
        text = String(spec_text);
      }

      text = text.replace(/\r\n/g, '\n').trim();

      if (!text) {
        return [];
      }

      return text
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => !!line);
    },

    to_section_blocks(lines) {
      const heading_regex = /^([A-J])\.\s*(.+)$/i;
      const sections = [];
      let current_section = null;

      for (const line of lines) {
        const heading_match = line.match(heading_regex);
        if (heading_match) {
          current_section = { code: heading_match[1].toUpperCase(), heading: heading_match[2].trim(), lines: [] };
          sections.push(current_section);
          continue;
        }

        if (!current_section) {
          current_section = { code: '', heading: 'Overview', lines: [] };
          sections.push(current_section);
        }
        current_section.lines.push(line);
      }

      return sections;
    },

    parse_tab_row(line) {
      const tab_index = line.indexOf('\t');
      if (tab_index < 0) {
        return null;
      }
      const label = line.slice(0, tab_index).trim();
      const value = line.slice(tab_index + 1).trim();
      if (!label) {
        return null;
      }
      const tab_row = { label, value: value || '-' };
      return tab_row;
    },

    parse_colon_row(line) {
      const colon_match = line.match(/^([^:]{2,50}):\s*(.+)$/);
      if (!colon_match) {
        return null;
      }
      const colon_row = {
        label: colon_match[1].trim(),
        value: colon_match[2].trim() || '-',
      };
      return colon_row;
    },

    parse_section_content(lines) {
      const parsed = { rows: [], bullets: [], paragraphs: [] };

      for (const line of lines) {
        if (/^[•-]\s*/.test(line)) {
          parsed.bullets.push(line.replace(/^[•-]\s*/, '').trim());
          continue;
        }

        const tab_row = this.parse_tab_row(line);
        if (tab_row) {
          parsed.rows.push(tab_row);
          continue;
        }

        const colon_row = this.parse_colon_row(line);
        if (colon_row) {
          parsed.rows.push(colon_row);
          continue;
        }

        parsed.paragraphs.push(line);
      }

      return parsed;
    },

    build_job_spec_sections(spec_text) {
      const section_blocks = this.to_section_blocks(this.get_spec_lines(spec_text));
      return section_blocks.map((section) => {
        const parsed = this.parse_section_content(section.lines || []);
        const section_payload = {
          code: section.code,
          heading: section.heading,
          rows: parsed.rows,
          bullets: parsed.bullets,
          paragraphs: parsed.paragraphs,
        };
        return section_payload;
      });
    },

    extract_job_purpose(spec_text, fallback_text) {
      const sections = this.build_job_spec_sections(spec_text);
      const purpose_section = sections.find((section) => section.code === 'B');
      if (purpose_section) {
        const first_paragraph = purpose_section.paragraphs?.[0] || '';
        if (first_paragraph) {
          return first_paragraph;
        }
      }
      return fallback_text || 'No job purpose has been provided.';
    },

    group_attribute_questions(attribute_questions = []) {
      if (!attribute_questions.length) {
        return [];
      }

      return [{
        section_name: 'General Form Questions',
        questions: attribute_questions,
      }];
    },

    format_period(published_date, closing_date) {
      const from = published_date ? new Date(published_date).toLocaleDateString() : 'Open';
      const to = closing_date ? new Date(closing_date).toLocaleDateString() : 'Open';
      return `${from} to ${to}`;
    },

    format_display_date(date_str) {
      if (!date_str) return '';
      const d = new Date(date_str);
      if (isNaN(d.getTime())) return date_str;
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    },

    format_display_datetime(date_str) {
      if (!date_str) return '';
      const date = new Date(date_str);
      if (isNaN(date.getTime())) return date_str;

      const has_time =
        typeof date_str === 'string'
        && (/[T\s]\d{2}:\d{2}/.test(date_str) || /\d{2}:\d{2}/.test(date_str));

      const formatted_date = date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });

      if (!has_time) {
        return formatted_date;
      }

      const formatted_time = date.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
      });

      return `${formatted_date} - ${formatted_time}`;
    },

    normalize_job(job_row, advert_row = null) {
      const job_title = this.read_prop(job_row, 'entity_type_name', 'Untitled Job');
      const form_sections_data = this.read_prop(job_row, 'form_sections', []);
      const attribute_questions = this.read_prop(job_row, 'attribute_questions', []);
      const raw_spec_text = this.read_prop(job_row, 'job_spec_text', this.read_prop(job_row, 'entity_type_description', ''));
      const form_sections = form_sections_data.length ? form_sections_data : this.group_attribute_questions(attribute_questions);
      const advert = advert_row || {};
      const closing_date = this.read_prop(advert, 'closing_date', this.read_prop(job_row, 'closing_date', null));
      const published_date = this.read_prop(advert, 'published_date', this.read_prop(job_row, 'published_date', null));
      const reference_number = this.read_prop(advert, 'reference_number', this.read_prop(job_row, 'reference_number', '-'));
      const advert_title = this.read_prop(advert, 'title', job_title);
      const advert_details = this.read_prop(advert, 'details', this.read_prop(job_row, 'entity_type_description', 'No details were provided for this job profile.'));

      const normalized_job = {
        id: this.read_prop(job_row, 'id', null),
        advertId: this.read_prop(advert, 'id', null),
        alreadyApplied: false,
        applicationState: null,
        projectId: this.read_prop(job_row, 'project_id', null),
        subProgramId: this.read_prop(job_row, 'sub_program_id', null),
        subProgramName: this.read_prop(job_row, 'sub_program_name', null),
        title: advert_title,
        jobTitle: advert_title,
        status: this.infer_job_status(closing_date),
        recruitingPeriod: this.format_period(published_date, closing_date),
        informationSummary: this.read_prop(job_row, 'information_summary', []),
        formSections: form_sections,
        jobSpecSections: this.build_job_spec_sections(raw_spec_text),
        jobPurpose: this.extract_job_purpose(raw_spec_text, this.read_prop(job_row, 'entity_type_description', '')),
        rawSpecText: raw_spec_text,
        details: advert_details,
        shareLink: this.read_prop(job_row, 'share_link', ''),
        referenceNumber: reference_number,
        publishedDate: published_date,
        closingDate: closing_date,
        competencies: [],
      };
      return normalized_job;
    },

    async _fetch_application_state_sets() {
      const resp = await axios.get(GET_USER_APPLIED_ENTITY_TYPE_IDS_URL, { headers: get_headers() });
      return {
        applied_advert_ids: new Set((resp?.data?.applied_advert_ids || []).map(Number).filter(Boolean)),
        archived_advert_ids: new Set((resp?.data?.archived_advert_ids || []).map(Number).filter(Boolean)),
        applied_entity_type_ids: new Set((resp?.data?.applied_entity_type_ids || []).map(Number).filter(Boolean)),
        archived_entity_type_ids: new Set((resp?.data?.archived_entity_type_ids || []).map(Number).filter(Boolean)),
      };
    },

    async sync_applied_state() {
      if (!get_token()) return;
      try {
        const state_sets = await this._fetch_application_state_sets();
        this.jobs = (this.jobs || []).map((job) => ({
          ...job,
          applicationState:
            (Number(job.advertId) > 0 && state_sets.applied_advert_ids.has(Number(job.advertId)))
              || state_sets.applied_entity_type_ids.has(Number(job.id))
              ? 'applied'
              : ((Number(job.advertId) > 0 && state_sets.archived_advert_ids.has(Number(job.advertId)))
                || state_sets.archived_entity_type_ids.has(Number(job.id))
                ? 'archived'
                : null),
          alreadyApplied:
            (Number(job.advertId) > 0 && state_sets.applied_advert_ids.has(Number(job.advertId)))
              || state_sets.applied_entity_type_ids.has(Number(job.id)),
        }));
      } catch {
        // Keep jobs visible if sync fails.
      }
    },

    async check_single_job_applied(entity_type_id, advert_id) {
      if (!get_token() || !entity_type_id) return false;
      try {
        const resp = await axios.get(CHECK_APPLIED_STATUS_URL, {
          params: { entity_type_id, advert_id },
          headers: get_headers(),
        });
        return {
          alreadyApplied: resp?.data?.already_applied === true,
          applicationState: this.normalize_application_state(resp?.data?.application_state),
        };
      } catch {
        return {
          alreadyApplied: false,
          applicationState: null,
        };
      }
    },

    update_selected_job_application_state(application_state) {
      const normalized_state = this.normalize_application_state(application_state);
      const selected_advert_id = Number(this.job?.advertId || 0);
      const selected_entity_type_id = Number(this.job?.id || 0);

      this.job = {
        ...this.job,
        applicationState: normalized_state,
        alreadyApplied: normalized_state === 'applied',
      };

      this.jobs = (this.jobs || []).map((job) => {
        const job_advert_id = Number(job?.advertId || 0);
        const job_entity_type_id = Number(job?.id || 0);
        const is_same_advert = selected_advert_id && job_advert_id === selected_advert_id;
        const is_same_entity_when_no_advert = !selected_advert_id && job_entity_type_id === selected_entity_type_id;

        if (is_same_advert || is_same_entity_when_no_advert) {
          return {
            ...job,
            applicationState: normalized_state,
            alreadyApplied: normalized_state === 'applied',
          };
        }

        return job;
      });
    },

    go_to_page(page) {
      if (page >= 1 && page <= this.total_pages) {
        this.current_page = page;
      }
    },

    async fetch_jobs_for_all_projects() {
      this.loading_jobs = true;
      try {
        const response = await axios.get(PUBLIC_JOB_CATALOG_URL);
        const parsed_response = this.normalize_api_payload(response.data);
        const payload = parsed_response?.data || {};
        this.projects = payload.departments || [];
        this.sub_programs = payload.sub_programs || [];
        const job_rows = payload.jobs || [];
        this.jobs = job_rows.flatMap((job_row) => {
          const adverts = Array.isArray(job_row?.adverts) && job_row.adverts.length
            ? job_row.adverts
            : [];

          const seen_advert_ids = new Set();
          const unique_open_adverts = adverts.filter((advert) => {
            const advert_id = Number(advert?.id || 0);
            if (!advert_id || seen_advert_ids.has(advert_id)) {
              return false;
            }
            seen_advert_ids.add(advert_id);
            return true;
          });

          return unique_open_adverts.map((advert_row) => this.normalize_job(job_row, advert_row));
        });
        this.current_page = 1;

        await this.sync_applied_state();

        const default_share_link = this.read_prop(this.jobs[0], 'shareLink', '');
        if (default_share_link) {
          sessionStorage.setItem('public_default_share_link', default_share_link);
        }

        this.has_loaded_jobs_once = true;
      } catch (error) {
        const message = error.response?.data?.message || error.message || 'Unknown error';
        this.show_error('Error loading jobs: ' + message);
      } finally {
        this.loading_jobs = false;
      }
    },

    async open_job_details(selected_job) {
      // Check applied state for this specific job directly from the API.
      const status_result = await this.check_single_job_applied(
        selected_job?.id,
        selected_job?.advertId,
      );

      // Reflect the result back into the jobs list so the card state stays in sync.
      if (status_result.alreadyApplied || status_result.applicationState) {
        this.jobs = (this.jobs || []).map((j) =>
          j.id === selected_job.id && j.advertId === selected_job.advertId
            ? {
                ...j,
                applicationState: status_result.applicationState,
                alreadyApplied: status_result.alreadyApplied,
              }
            : j
        );
      }


      this.job = {
        ...selected_job,
        alreadyApplied: status_result.alreadyApplied,
        applicationState: status_result.applicationState,
        competencies: [],
      };

      const selected_share_link = this.read_prop(selected_job, 'shareLink', '');
      if (selected_share_link) {
        sessionStorage.setItem('public_job_share_link', selected_share_link);
      }

      // Load full profile from backend (same API as ViewJobProfile)
      await this.load_job_profile_for_modal(selected_job.id, selected_job.advertId);
      // Load advert-specific data/order for public view
      await this.load_advert_data_for_modal(selected_job.id, selected_job.advertId);
    },

    async load_advert_data_for_modal(entity_type_id, advert_id = null) {
      if (!entity_type_id) return;

      try {
        const response = await axios.get(`${PUBLIC_JOB_ADVERT_URL}?entity_type_id=${entity_type_id}`);

        if (response.data?.status === 'success' && response.data?.data?.length > 0) {
          const adverts = Array.isArray(response.data.data) ? response.data.data : [];
          const advert = adverts
            .slice()
            .sort((left, right) => {
              const left_time = new Date(left?.updated_at || left?.date_modified || left?.date_created || 0).getTime();
              const right_time = new Date(right?.updated_at || right?.date_modified || right?.date_created || 0).getTime();

              if (left_time !== right_time) {
                return right_time - left_time;
              }

              return (Number(right?.id) || 0) - (Number(left?.id) || 0);
            })
            .find((row, index, list) => {
              if (!advert_id) {
                return index === 0;
              }
              return Number(row?.id) === Number(advert_id) || (index === 0 && !list.some(item => Number(item?.id) === Number(advert_id)));
            });

          if (!advert) {
            return;
          }

          const split = this.split_advert_sections_and_order(advert.sections || []);
          this.job_profile.advert_details = advert.details || '';
          this.job_profile.advert_sections = split.content_sections;
          this.job_profile.advert_order = split.order_items;
          this.refresh_job_profile_display_blocks();
        } else {
          this.job_profile.advert_details = '';
          this.job_profile.advert_sections = [];
          this.job_profile.advert_order = [];
          this.refresh_job_profile_display_blocks();
        }
      } catch (error) {
        console.warn('Could not load advert data:', error.message);
      }
    },

    async load_job_profile_for_modal(entity_type_id, advert_id = null) {
      if (!entity_type_id) return;
      this.loading_profile = true;
      this.job_profile = {
        title: '',
        description: '',
        sections: [],
        advert_details: '',
        advert_sections: [],
        advert_order: [],
        display_blocks: [],
      };

      try {
        const response = await axios.get(GET_JOB_PROFILE_DETAILS_URL, {
          params: { entity_type_id, advert_id },
        });

        const wrapper = response.data || {};
        const data = wrapper.data || wrapper;

        if (data && typeof data === 'object') {
          this.job_profile = {
            title: data.job_title || data.title || this.job.jobTitle || 'Untitled Job Profile',
            description: data.description || '',
            sections: this.normalize_profile_sections(data.sections || []),
            advert_details: '',
            advert_sections: [],
            advert_order: [],
            display_blocks: [],
          };
          this.refresh_job_profile_display_blocks();
        }

        const application_state = this.normalize_application_state(wrapper.application_state);
        if (application_state) {
          this.job = {
            ...this.job,
            applicationState: application_state,
            alreadyApplied: application_state === 'applied',
          };
        }
      } catch (error) {
        // Silently fall back — the modal will show the fallback state
        console.warn('Could not load job profile details:', error.message);
      } finally {
        this.loading_profile = false;
      }
    },

    normalize_profile_sections(raw_sections) {
      if (!Array.isArray(raw_sections)) return [];
      return raw_sections.map(section => ({
        title: section.title || '',
        descriptions: Array.isArray(section.descriptions) ? section.descriptions : [],
        table: section.table || { headers: [{ label: 'Column 1' }], rows: [['']] },
        use_columns: section.use_columns === true,
        show_on_advert: section.show_on_advert !== false,
        subsections: Array.isArray(section.subsections)
          ? section.subsections.map(subsection => ({
              title: subsection.title || '',
              descriptions: Array.isArray(subsection.descriptions) ? subsection.descriptions : [],
              table: subsection.table || { headers: [{ label: 'Column 1' }], rows: [['']] },
              use_columns: subsection.use_columns === true,
              show_on_advert: subsection.show_on_advert !== false,
            }))
          : [],
      }));
    },

    split_advert_sections_and_order(raw_sections) {
      const list = Array.isArray(raw_sections) ? JSON.parse(JSON.stringify(raw_sections)) : [];
      const meta = list.find(item => item && item.type === '__display_order_meta__' && Array.isArray(item.items));
      return {
        content_sections: list.filter(item => !(item && item.type === '__display_order_meta__')),
        order_items: meta?.items || [],
      };
    },

    build_default_display_order(profile_sections, advert_details, advert_sections) {
      const order = [];
      (profile_sections || []).forEach((_, idx) => order.push({ key: `profile:${idx}`, source: 'profile', index: idx }));
      if (advert_details && String(advert_details).trim()) order.push({ key: 'details', source: 'details' });
      (advert_sections || []).forEach((_, idx) => order.push({ key: `section:${idx}`, source: 'section', index: idx }));
      return order;
    },

    normalize_display_order(saved_order, profile_sections, advert_details, advert_sections) {
      const fallback = this.build_default_display_order(profile_sections, advert_details, advert_sections);
      const allowed = new Set(fallback.map(item => item.key));
      const normalized = [];

      if (Array.isArray(saved_order)) {
        saved_order.forEach(item => {
          if (item && allowed.has(item.key) && !normalized.some(entry => entry.key === item.key)) {
            normalized.push(item);
          }
        });
      }

      fallback.forEach(item => {
        if (!normalized.some(entry => entry.key === item.key)) {
          normalized.push(item);
        }
      });

      return normalized;
    },

    refresh_job_profile_display_blocks() {
      const profile_sections = this.visible_profile_sections || [];
      const advert_sections = this.job_profile.advert_sections || [];
      const advert_details = this.job_profile.advert_details || '';
      const order = this.normalize_display_order(this.job_profile.advert_order || [], profile_sections, advert_details, advert_sections);

      this.job_profile.display_blocks = order
        .map(item => this.build_job_profile_display_block(item, profile_sections, advert_details, advert_sections))
        .filter(block => !!block.data);
    },
    build_section_display_block(item, sections) {
      return {
        key: item.key,
        kind: 'section',
        title: sections[item.index]?.title || `Section ${item.index + 1}`,
        data: sections[item.index] || null,
      };
    },
    build_details_display_block(item, advert_details) {
      return {
        key: item.key,
        kind: 'details',
        title: 'Additional Information',
        data: advert_details,
      };
    },
    build_job_profile_display_block(item, profile_sections, advert_details, advert_sections) {
      if (item.source === 'profile') {
        return this.build_section_display_block(item, profile_sections);
      }
      if (item.source === 'details') {
        return this.build_details_display_block(item, advert_details);
      }
      return this.build_section_display_block(item, advert_sections);
    },

    clean_html(html) {
      if (!html) return '';
      let str = String(html);
      str = str.replace(/<p>\s*<\/p>/g, '').trim();
      if (!str.includes('<') && str.includes('\n')) {
        str = str.replace(/\n/g, '<br>');
      }
      return str;
    },

    section_badge_label(title) {
      const value = String(title || '').trim();
      const match = value.match(/^([A-Z])\.\s*/i);
      return match ? match[1].toUpperCase() : (value.charAt(0).toUpperCase() || 'A');
    },

    section_display_title(title) {
      const value = String(title || '').trim();
      return value.replace(/^[A-Z]\.\s*/i, '') || value;
    },

    strip_html_tags(text) {
      if (!text) return '';
      return String(text).replace(/<[^>]+>/g, '').trim();
    },

    has_table_content(section) {
      if (!section.table || !Array.isArray(section.table.rows)) return false;
      for (const row of section.table.rows) {
        if (!Array.isArray(row)) continue;
        for (const cell of row) {
          const cleaned = this.strip_html_tags(cell || '');
          if (cleaned && cleaned.trim().length > 0) return true;
        }
      }
      return false;
    },

    redirect_to_my_jobs(){
      this.$router.push('/view_all_user_forms');
    },

    async applyForJob() {
      if (!this.job?.id) {
        this.show_error('Please select a job first.');
        return;
      }

      if (this.job.status === 'Closed') {
        this.show_error('This advert is closed and cannot accept new applications.');
        return;
      }

      if (this.job.alreadyApplied === true) {
        this.show_info('You already applied for this job. Please see other jobs available.');
        return;
      }

      const token = get_token();

      // User is already logged in — create application directly
      if (token) {
        try {
          const response = await axios.post(
            APPLY_FOR_ENTITY_TYPE,
            {
              entity_type_id: this.job.id,
              advert_id: this.job.advertId,
            },
            { headers: get_headers() }
          );

          const data = response.data;

          if (data.status === 'success') {
            if (data.already_applied === true) {
              this.update_selected_job_application_state(data.application_state || 'applied');
              const modal_el = document.getElementById('job-details-modal');
              if (modal_el) {
                const modal = window.bootstrap?.Modal?.getInstance(modal_el);
                if (modal) modal.hide();
              }
              this.show_info(data.message || 'You already applied for this job. Please see other jobs available.');
              return;
            }

            // Close modal first
            const modal_el = document.getElementById('job-details-modal');
            if (modal_el) {
              const modal = window.bootstrap?.Modal?.getInstance(modal_el);
              if (modal) modal.hide();
            }

            if (data.application_form_id) {
              this.update_selected_job_application_state(data.application_state || 'archived');
              sessionStorage.setItem('application_form_id', data.application_form_id);
              sessionStorage.setItem('entity_applying', 'true');
              this.$router.push({
                path: '/attribute_forms',
                query: { application_form_id: String(data.application_form_id) },
              });
            } else {
              this.show_info('Your application has been created. No form has been assigned to this job yet.');
            }
          } else {
            this.show_error(data.message || 'Could not create application.');
          }
        } catch (error) {
          const msg = error.response?.data?.message || 'Error creating application.';
          this.show_error(msg);
        }
        return;
      }

      // Not logged in — redirect to the job's sign-up page
      if (!this.job.shareLink) {
        this.show_error('Onboarding link is not available for this job yet.');
        return;
      }

      try {

        const response = await axios.get(GET_ALL_USER_APPLICATIONS, {
          headers: this.headers
        });

        const applications = response?.data?.data || [];

        if (applications.length > 0) {

          const result = await this.show_confirm(
            "Existing Application Found",
            "You already have existing applications. Do you want to use your existing data?",
            "Yes, use existing data",
            "No, start a new application"
          );

          // Wait for the user's choice
          if (result.isConfirmed) {

            sessionStorage.setItem("use_existing_application", "true");
            this.proceed_with_job_application();

          } else if (result.dismiss) {

            sessionStorage.removeItem("use_existing_application");
            this.proceed_with_job_application();

          }

        } else {

          this.proceed_with_job_application();

        }

      } catch (error) {
        this.proceed_with_job_application();
      }
    },

    proceed_with_job_application() {

      sessionStorage.setItem('apply_job_id', String(this.job.id));
      sessionStorage.setItem('apply_job_title', this.job.jobTitle || this.job.title || '');
      sessionStorage.setItem('apply_advert_id', this.job.advertId ? String(this.job.advertId) : '');

      window.location.assign(this.job.shareLink);

    }
  },
};
